export default __webpack_public_path__ + "static/media/step-seven.8dcd15c9.png";